export const MARITAL_STATUS_AR = {
  single: 'أعزب',
  married: 'متزوج',
  divorced: 'مطلق',
  widowed: 'أرمل'
} as const;

export const EDUCATION_LEVEL_AR = {
  primary: 'ابتدائي',
  intermediate: 'متوسط',
  secondary: 'ثانوي',
  bachelor: 'جامعي',
  master: 'ماجستير',
  doctorate: 'دكتوراه',
  other: 'أخرى'
} as const;

export type MaritalStatus = keyof typeof MARITAL_STATUS_AR;
export type EducationLevel = keyof typeof EDUCATION_LEVEL_AR;